import { generateReducer, } from "../generators/generator.reducer";
import { GENERATOR_PARAMS } from "./paymentGroup.constants";
var getExtraDefaultState = function (state) { return ({}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
// eslint-disable-next-line import/no-default-export
export default reducer;
